import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=674986e4&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHintCarousel: require('/usr/src/motec/components/page/HintCarousel.vue').default,PageMainContent: require('/usr/src/motec/components/page/main/Content.vue').default,PageSuggestedLinks: require('/usr/src/motec/components/page/SuggestedLinks.vue').default,PageColumnContent: require('/usr/src/motec/components/page/column/Content.vue').default,Spinner: require('/usr/src/motec/components/Spinner.vue').default,Error: require('/usr/src/motec/components/Error.vue').default})
